import { App } from 'ionic-angular';
import {
  ContentPage,
} from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/page.interface';
import { DataSource } from '../../interfaces/data-source.interface';
import { DataSourceConfig } from '../../interfaces/data-source-config.interface';
import { ENVIRONMENT } from '../../../../../environments/environment';
import {
  FilterOutput,
} from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/filter-outpt.interface';
import {
  FiltersConfig,
} from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/filters-config.interface';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SellionsCalendarEvent } from '../../interfaces/sellions-calendar-event.interface';
import {
  FilterSet,
} from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/filter-set.interface';
import {
  FilterQueryValue,
} from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/filter-query-value.inteface';
import { ScreenActionCallback } from '../../../../shared/components/sellions-dynamic-event/screen-action-callback';
import {
  Utils,
} from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/utils/utils.class';

@Injectable()
export class CalendarDataViewDataSource implements DataSource {
  public eventLayout: string;
  private config: DataSourceConfig = {} as DataSourceConfig;
  private readonly baseUrl = ENVIRONMENT.engineUrl + 'api/data-view/';
  private _filters: FilterOutput[];
  private screenActionCallback: ScreenActionCallback;
  private dataContext: any;

  constructor(private app: App, private http: HttpClient) {}

  public get filters(): FilterOutput[] {
    return this._filters;
  }

  public getEvents(): Promise<SellionsCalendarEvent[]> {
    return this.http
      .get<ContentPage>(this.baseUrl + this.config.params.dataViewName)
      .map((data) => this.mapToSellionsCalendarEvents(data.content))
      .toPromise();
  }

  private mapToSellionsCalendarEvents(events: any[]): SellionsCalendarEvent[] {
    return events.map((event) => {
      let displayComponentData = this.config.displayComponent !== 'SellionsDynamicEventComponent' ? { event, title: event[this.config.params.titleColumn] } :
        {
          event,
          infoTextTemplate: this.config.params['infoTextTemplate'],
          subInfoTextTemplate: this.config.params['subInfoTextTemplate'],
          subDateTextTemplate: this.config.params['subDateTextTemplate'],
          additionalTextTemplate: this.config.params['additionalTextTemplate'],
          screenActions: this.config.screenActions,
          screenActionCallback: this.screenActionCallback
        };
      return ({
        displayComponent: this.config.displayComponent,
        displayComponentData: displayComponentData,
        dateFrom: event[this.config.params.startDateColumn],
        dateTo: event[this.config.params.endDateColumn],
        dataSource: this,
      });
    });
  }

  public filter(filters: FilterOutput[] | FilterSet): Promise<SellionsCalendarEvent[]> {
    let params = new HttpParams();
    this._filters = Array.isArray(filters) ? filters : filters.filters;
    if(this.config.staticFilters) {
      let staticFilters = this.config.staticFilters.map(filter => {
        let clonedFilter = JSON.parse(JSON.stringify(filter));
        clonedFilter['value'] = Utils.evaluateString(clonedFilter['value'], this.dataContext);
        clonedFilter['queryValue'] = JSON.parse(JSON.stringify(clonedFilter));
        return clonedFilter;
      });
      this._filters = [...this._filters, ...staticFilters];
    }
    let searchQuery = Array.isArray(filters) ? '' : filters.searchQuery;
    let url = this.baseUrl + this.config.params.dataViewName + this.generateFilterUrl(this._filters);
    url = url + (searchQuery ? this.generateSearchUrl(url, searchQuery) : '');
    return this.http
      .get<ContentPage>(url, { params })
      .map((data) => this.mapToSellionsCalendarEvents(data.content))
      .toPromise();
  }

  private generateFilterUrl(filters?: FilterOutput[]): string {
    const queryFilters: FilterQueryValue[] = [];
    filters.forEach((filter) => {
      if (filter.queryValue.value) {
        const sameColumnFilterIndex = queryFilters.findIndex((f) => f.column === filter.column);

        if (sameColumnFilterIndex > -1) {
          if (queryFilters[sameColumnFilterIndex].type === 'COMPOUND') {
            queryFilters[sameColumnFilterIndex].subFilters.push(filter.queryValue);
          } else {
            const sameColumnFilter = queryFilters.splice(sameColumnFilterIndex, 1);
            const compoundFilter = this.createCompoundFilter(...sameColumnFilter, filter.queryValue);
            queryFilters.push(compoundFilter);
          }
        } else {
          queryFilters.push(filter.queryValue);
        }
      }
    });

    if (queryFilters.length < 1) {
      return '';
    }

    return '?filters=' + encodeURIComponent(JSON.stringify({ filters: queryFilters }));
  }

  private createCompoundFilter(...filters: FilterQueryValue[]): FilterQueryValue {
    return {
      column: filters[0].column, // For contact purposes only - the backend ignores this value for the COMPOUND filter
      type: 'COMPOUND',
      subFilters: filters,
    };
  }

  private generateSearchUrl(url: string, searchQuery: string): string {
    if (url.includes('?')) {
      return '&searchQuery=' + searchQuery;
    }

    return '?searchQuery=' + searchQuery;
  }

  public search(query: string): Promise<SellionsCalendarEvent[]> {
    return this.filter([{ type: 'input', value: query, column: 'searchQuery', queryValue: null }]);
  }

  public async detailsOnClick(event: SellionsCalendarEvent) {
    return this.app.getRootNav().push(this.config.detailsOnClick.component, { ...this.config.detailsOnClick.componentData, event, calendar: true });
  }

  public setConfig(config: DataSourceConfig): void {
    this.config = config;
  }

  public getFiltersConfig(): FiltersConfig {
    return this.config.filters;
  }

  getRawEvent(event: SellionsCalendarEvent) {
    return event.displayComponentData.event;
  }

  setOnScreenActionCallback(ref: ScreenActionCallback): void {
    this.screenActionCallback = ref;
  }

  public setDataContext(context: any) {
    this.dataContext = context;
  }
}



// WEBPACK FOOTER //
// ./src/modules/calendar/services/data-view-data-source/data-view-data-source.class.ts